<template>
  <div
    class="hamburger p-relative cursor-pointer ms-4"
    @click.prevent.stop="handleChangeVisibility"
  >
    <div
      data-grid="column"
      class="hamburger__wrapper grid--between w-100 h-100"
    >
      <span class="w-100" />
      <span class="w-100" />
      <span class="w-60" />

      <div
        class="hamburger__content p-fixed"
        :class="{ 'hamburger__content--visible': visibility }"
      >
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'HamburgerMenu',

  props: {
    modelValue: {
      type: Boolean,
      required: true
    }
  },

  emits: ['update:modelValue'],

  computed: {
    visibility: {
      get () {
        return this.modelValue
      },

      set (v) {
        this.$emit('update:modelValue', v)
      }
    }
  },

  methods: {
    handleChangeVisibility () {
      this.visibility = !this.visibility
    }
  }
})
</script>

<style lang="scss" scoped>
  .hamburger {
    width: 26px;
    height: 21px;

    &__wrapper > span {
      height: 3px;
      border-radius: 3px;

      background-color: rgb(var(--white));
    }

    &__content {
      opacity: 0;
      visibility: hidden;

      &--visible {
        opacity: 1;
        visibility: visible;
      }
    }
  }
</style>
